import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../shared/utils/apiConfig';

const CLINIC_DASH_PREFIX = '/clinics_dash';

export const fetchClinicBranches = createAsyncThunk(
    'clinicBranches/fetch',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiClient.get(`${CLINIC_DASH_PREFIX}/clinic_branchs`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب فروع العيادة');
        }
    }
);

export const addClinicBranch = createAsyncThunk(
    'clinicBranches/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiClient.post(`${CLINIC_DASH_PREFIX}/add_new_branch`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في إضافة الفرع');
        }
    }
);

export const updateClinicBranch = createAsyncThunk(
    'clinicBranches/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await apiClient.post(`${CLINIC_DASH_PREFIX}/edit_branch/${id}`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في تعديل بيانات الفرع');
        }
    }
);

export const updateClinicBranchStatus = createAsyncThunk(
    'clinicBranches/updateStatus',
    async ({ id, status }, { rejectWithValue }) => {
        try {
            const response = await apiClient.post(`${CLINIC_DASH_PREFIX}/edit_branch_status/${id}`, { status });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في تغيير حالة الفرع');
        }
    }
);

export const deleteClinicBranch = createAsyncThunk(
    'clinicBranches/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiClient.delete(`${CLINIC_DASH_PREFIX}/delete_branch/${id}`);
            return response.data ?? { id };
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في حذف الفرع');
        }
    }
);

const initialState = {
    branches: [],
    loading: false,
    error: null
};

const clinicBranchesSlice = createSlice({
    name: 'clinicBranches',
    initialState,
    reducers: {
        clearClinicBranchesError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchClinicBranches.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchClinicBranches.fulfilled, (state, action) => {
                state.loading = false;
                const payload = action.payload;
                const list =
                    payload?.result?.data ??
                    payload?.result ??
                    payload?.data ??
                    payload?.branches ??
                    payload?.branchs ??
                    [];
                state.branches = Array.isArray(list) ? list : [];
            })
            .addCase(fetchClinicBranches.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addClinicBranch.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateClinicBranch.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateClinicBranchStatus.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteClinicBranch.rejected, (state, action) => {
                state.error = action.payload;
            });
    }
});

export const { clearClinicBranchesError } = clinicBranchesSlice.actions;
export default clinicBranchesSlice.reducer;

